import TagManager from 'react-gtm-module';

const GTM_ENVIRONMENTS = ['develop', 'testing', 'production'];

const environment = import.meta.env.VITE_APP_TRIPLABO_ENV || '';

if (GTM_ENVIRONMENTS.includes(environment)) {
  TagManager.initialize({ gtmId: 'GTM-PQNQVDRQ' });
}
